import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-8 md:mb-12" }
const _hoisted_2 = { class: "mb-4 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }, null, -1)
const _hoisted_4 = { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }
const _hoisted_5 = { class: "flex flex-row w-full md:justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "-", -1)
const _hoisted_7 = { class: "mb-16 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_8 = { class: "w-full mb-4 md:mb-0 md:w-3/5" }
const _hoisted_9 = { class: "flex flex-col md:flex-row items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download text-big mr-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-drop ml-2 text-small" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus ml-2 text-medium mr-1" }, null, -1)
const _hoisted_13 = { class: "hidden md:flex flex-row justify-between px-4 mb-5 text-light font-bold text-headings-gray" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_15 = { class: "w-1/12" }
const _hoisted_16 = { class: "w-1/6" }
const _hoisted_17 = { class: "w-1/12" }
const _hoisted_18 = { class: "w-1/6" }
const _hoisted_19 = { class: "w-1/6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/6" }, " ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12 flex flex-row justify-end" }, [
  /*#__PURE__*/_createElementVNode("input", { type: "checkbox" })
], -1)
const _hoisted_22 = {
  key: 0,
  class: "rounded bg-white p-6 md:px-4 flex flex-col md:items-center relative mb-5 md:flex-row justify-center font-bold text-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker_input = _resolveComponent("datepicker-input")!
  const _component_search_input = _resolveComponent("search-input")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_bulk_parcel_list_item = _resolveComponent("bulk-parcel-list-item")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_create_bulk_parcels_modal = _resolveComponent("create-bulk-parcels-modal")!
  const _component_edit_bulk_parcels_modal = _resolveComponent("edit-bulk-parcels-modal")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("bulk_parcels.list.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_datepicker_input, {
            class: "mr-5 md:w-1/4",
            placeholder: "filters.from_date",
            onDateUpdate: _ctx.dateFromUpdate
          }, null, 8, ["onDateUpdate"]),
          _hoisted_6,
          _createVNode(_component_datepicker_input, {
            class: "ml-5 md:w-1/4",
            placeholder: "filters.to_date",
            onDateUpdate: _ctx.dateToUpdate
          }, null, 8, ["onDateUpdate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_search_input, {
          placeholder: "bulk_parcels.list.filters.search",
          isLoading: _ctx.isLoading,
          onSearchUpdate: _ctx.searchUpdate,
          onSearchAction: _ctx.getList
        }, null, 8, ["isLoading", "onSearchUpdate", "onSearchAction"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_default_button, {
          class: "w-full md:w-auto mb-2 md:mb-0",
          type: "empty",
          onClick: _ctx.downloadTemplate
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_parcels.list.actions.csv_template")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_default_button, {
          class: "w-full mb-2 md:mb-0 md:w-auto",
          type: "outline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("bulk_parcels.list.actions.action")) + " ", 1),
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_default_button, {
          class: "w-full md:w-auto md:ml-4",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_parcels.list.actions.create_bulk_order")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("bulk_parcels.list.item.id")), 1),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("bulk_parcels.list.item.created")), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("bulk_parcels.list.item.shipment")), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("bulk_parcels.list.item.parcels_with_errors")), 1),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("bulk_parcels.list.item.status")), 1),
        _hoisted_20,
        _hoisted_21
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_spinner, {
            key: 0,
            class: "mx-auto"
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.bulkParcels.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t(_ctx.loadFailed ? "general.list_load_error" : "general.empty_list")), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulkParcels, (bulkParcel) => {
              return (_openBlock(), _createBlock(_component_bulk_parcel_list_item, {
                key: bulkParcel.id,
                "bulk-parcel": bulkParcel,
                onEditBulkParcel: _ctx.editBulkParcel
              }, null, 8, ["bulk-parcel", "onEditBulkParcel"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.pagination)
        ? (_openBlock(), _createBlock(_component_pagination, {
            key: 2,
            "total-rows": 20,
            meta: _ctx.pagination,
            onChangePagination: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList($event.page, $event.perPage)))
          }, null, 8, ["meta"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
      "hide-buttons": true,
      onCancelClick: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(!_ctx.editingBulkParcelId
            ? _ctx.$t("bulk_parcels.create.title")
            : _ctx.$t("bulk_parcels.edit.title")), 1)
      ]),
      default: _withCtx(() => [
        (!_ctx.editingBulkParcelId)
          ? (_openBlock(), _createBlock(_component_create_bulk_parcels_modal, {
              key: 0,
              onCloseModal: _ctx.closeModal,
              onBulkParcelCreateCompleted: _ctx.bulkParcelCreateCompleted
            }, null, 8, ["onCloseModal", "onBulkParcelCreateCompleted"]))
          : _createCommentVNode("", true),
        (_ctx.editingBulkParcelId)
          ? (_openBlock(), _createBlock(_component_edit_bulk_parcels_modal, {
              key: 1,
              bulkParcelId: _ctx.editingBulkParcelId,
              bulkParcelDescription: _ctx.editingBulkParcelDescription,
              onCloseModal: _ctx.closeModal,
              onBulkParcelEditCompleted: _ctx.bulkParcelEditCompleted
            }, null, 8, ["bulkParcelId", "bulkParcelDescription", "onCloseModal", "onBulkParcelEditCompleted"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onCancelClick"])
  ]))
}